import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from '../shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class PackagesService {

  constructor(private http: HttpClient) {}
  addPackage(body) {
    return this.http.post<ApiResponseModel>('api/package', body);
  }

  getSinglePackageById(packageId) {
    return this.http.get<ApiResponseModel>('api/package/' + packageId);
  }
  getAllPackages() {
    return this.http.get<ApiResponseModel>('api/package');
  }
  getAllPackageTypes() {
    return this.http.get<ApiResponseModel>('api/package/types');
  }
  updatePackage(body, packageId) {
    return this.http.put<ApiResponseModel>(
      'api/package/' + packageId,
      body
    );
  }
  updatePackagePicture(body, experienceID) {
    return this.http.put<ApiResponseModel>(
      'api/package/updatePicture/' + experienceID,
      body
    );
  }
  getAvailablityPackage(id) {
    return this.http.get<ApiResponseModel>('api/availability/package/' + id);
  }
  insertAvailablityLocal(body, id) {
    return this.http.post<ApiResponseModel>(
      'api/availability/local/' + id,
      body
    );
  }
  getAvailablityLocal(id) {
    return this.http.get<ApiResponseModel>('api/availability/local/' + id);
  }
  patchAvailabilty(body, id) {
    return this.http.patch<ApiResponseModel>(
      'api/availability/local/' + id,
      body
    );
  }
  deleteAssignedLocal(id) {
    return this.http.delete<ApiResponseModel>('api/package/' + id + '/local');
  }
  insertAvailablityPackage(body, id) {
    return this.http.post<ApiResponseModel>(
      'api/availability/package/' + id,
      body
    );
  }
}
